import React, { Component } from "react";
import { Collapse } from "react-bootstrap";
import VideoItem from "../VideoItem/VideoItem";

class LeftPanel extends Component {
  videoClicked(video) {
    this.props.videoClicked(video);
  }
  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingOne" onClick={this.props.collapseClick}>
          <h4 className="panel-title">
            <a
              role="button"
              data-toggle="collapse"
              data-parent="#accordion"
              aria-expanded="true"
              aria-controls="collapseThree"
              className={this.props.open ? "collapsed" : ""}
            >
              <div className="numbercircle">{this.props.index + 1}</div>
              <h2>{this.props.category.VideoCategoryName}</h2>
              <div className="headersubline">
                <span>
                  <i className="fa fa-clock-o" />
                  {this.props.category.TotalTime}
                </span>
              </div>
            </a>
          </h4>
        </div>
        <Collapse in={this.props.open}>
          <div id="collapseThree" role="tabpanel" aria-labelledby="headingOne">
            <div className="panel-body">
              <ul className="clips m-0 p-0">
                {this.props.category.videos.map(video => {
                  return (
                    <VideoItem
                      key={video.Id}
                      isComplete={video.IsComplete}
                      isActive={video.IsActive}
                      title={video.Name}
                      time={video.Time}
                      videoClicked={() => this.videoClicked(video)}
                    />
                  );
                })}
              </ul>
            </div>
          </div>
        </Collapse>
      </div>
    );
  }
}

export default LeftPanel;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/LeftPanel.js